module.exports = __webpack_public_path__ + "static/media/2_1.a8c44975.png";